import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const UserIcon = observer(
    'UserIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='28'
            height='28'
            viewBox='0 0 28 28'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                stroke='#E4E4E7'
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M8.167 24.106v-1.94a2.333 2.333 0 0 1 2.333-2.333h7a2.333 2.333 0 0 1 2.333 2.334v1.939M25.667 14c0 6.443-5.224 11.667-11.667 11.667S2.333 20.443 2.333 14 7.557 2.333 14 2.333 25.667 7.557 25.667 14ZM17.5 11.667a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z'
            />
        </SvgElement>
    )
);
